module.exports = __webpack_public_path__ + "img/aff.ff700045.jpg";